import { ref } from '@vue/composition-api'
import CustomerApi from '@/api/waiter/Customer'
import { handleApiError } from '@/utils/errorHandler'

export const RANKING_TYPES = [
  { value: 'sales', text: '売上金額' },
  { value: 'visits', text: '来店回数' },
]

export const LIMIT_OPTIONS = [
  { value: 10, text: 'TOP 10' },
  { value: 20, text: 'TOP 20' },
  { value: 50, text: 'TOP 50' },
]

// 売上対象フィルター（collected_only: 売掛は回収分のみ+通常支払いを対象にする）
export const SALES_SCOPE_OPTIONS = [
  { value: 'all', text: '全ての売上' },
  { value: 'collected_only', text: '回収済みのみ' },
]

// 選択状態はモジュールスコープで保持する
// （一覧の絞り込みでカードが再マウントされても選択中のフィルターをリセットしない）
const selectedType = ref('sales')
const selectedLimit = ref(10)
const salesScope = ref('all')

export default function useCustomerRanking(vm) {
  const ranking = ref([])
  const loading = ref(false)
  const type = ref('sales')
  const limit = ref(10)
  const period = ref({ startDate: null, endDate: null })

  // フィルター連打時に古いレスポンスで上書きしないようリクエスト連番で守る
  let rankingRequestId = 0
  const fetchRanking = async ({
    rankingType = 'sales',
    rankingLimit = 10,
    startDate = null,
    endDate = null,
    salesScope: scope = 'all',
  } = {}) => {
    loading.value = true
    rankingRequestId += 1
    const requestId = rankingRequestId
    try {
      const res = await CustomerApi.getRanking({
        type: rankingType,
        limit: rankingLimit,
        startDate,
        endDate,
        salesScope: scope,
      })
      if (requestId !== rankingRequestId) return ranking.value

      type.value = res.data.type
      limit.value = res.data.limit
      period.value = res.data.period || {}
      ranking.value = res.data.ranking || []

      return ranking.value
    } catch (error) {
      if (requestId !== rankingRequestId) return []
      handleApiError(error, { $toast: vm.$toast })

      return []
    } finally {
      if (requestId === rankingRequestId) loading.value = false
    }
  }

  // ランキングCSV（大計＝リアルトータル・合計行付き）をAPIから取得する
  const downloadingCsv = ref(false)
  const fetchRankingCsv = async ({
    rankingType = 'sales',
    rankingLimit = 10,
    startDate = null,
    endDate = null,
    salesScope: scope = 'all',
  } = {}) => {
    downloadingCsv.value = true
    try {
      const res = await CustomerApi.getRankingCsv({
        type: rankingType,
        limit: rankingLimit,
        startDate,
        endDate,
        salesScope: scope,
      })

      return res.data
    } catch (error) {
      handleApiError(error, { $toast: vm.$toast })

      return null
    } finally {
      downloadingCsv.value = false
    }
  }

  const getTypeLabel = typeValue => {
    const found = RANKING_TYPES.find(t => t.value === typeValue)

    return found ? found.text : typeValue
  }

  return {
    ranking,
    loading,
    downloadingCsv,
    type,
    limit,
    period,
    selectedType,
    selectedLimit,
    salesScope,
    fetchRanking,
    fetchRankingCsv,
    getTypeLabel,
    RANKING_TYPES,
    LIMIT_OPTIONS,
    SALES_SCOPE_OPTIONS,
  }
}
